import {
  ChangeDetectionStrategy,
  Component,
  InputSignal,
  ModelSignal,
  OutputEmitterRef,
  Signal,
  computed,
  input,
  model,
  output,
} from '@angular/core';

import { ImageComponent } from '../image/image.component';

import { DisplaySize } from './display-size.type';

@Component({
  selector: 'mp-avatar',
  templateUrl: './avatar.component.html',
  styleUrl: './avatar.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [ImageComponent],
})
export class AvatarComponent {
  /* Content Properties */
  readonly image: ModelSignal<string | null | undefined> = model<string | null | undefined>();
  readonly name: InputSignal<string | null | undefined> = input<string | null | undefined>(undefined);

  /* Formatting Properties */
  readonly size: InputSignal<DisplaySize> = input<DisplaySize>('large');

  readonly imageLoadError: OutputEmitterRef<void> = output();

  protected readonly initials: Signal<string> = computed(() => this.buildNameInitials(this.name()));

  protected readonly avatarSizeCssClassObject: Signal<Record<string, boolean>> = computed(() => ({
    'avatar--tiny': this.size() === 'tiny',
    'avatar--small': this.size() === 'small',
    'avatar--medium': this.size() === 'medium',
    'avatar--large': this.size() === 'large',
  }));

  protected readonly placeholderImageUrl = 'assets/Avatar_Placeholder.jpeg';

  handleImageLoadError(): void {
    this.image.set(null);
    this.imageLoadError.emit();
  }

  private buildNameInitials(name?: string | null): string {
    if (!name) {
      return '';
    }

    const partsOfName = name.split(' ').filter((part: string) => !!part && part.length > 0);

    return partsOfName.length >= 2
      ? this.getFirstLetterUppercased(partsOfName[0]) + this.getFirstLetterUppercased(partsOfName[1])
      : this.getFirstLetterUppercased(name);
  }

  private getFirstLetterUppercased(value: string): string {
    return value.charAt(0).toUpperCase();
  }
}
